import React from "react";
import Gallery from "react-photo-gallery";
import proj1_1 from "../image/proj1_1.jpg";
import proj1_2 from "../image/proj1_2.jpg";
import proj1_3 from "../image/proj1_3.jpg";
import proj1_4 from "../image/proj1_4.jpg";
import proj1_5 from "../image/proj1_5.jpg";
import proj1_6 from "../image/proj1_6.jpg";
import proj1_7 from "../image/proj1_7.jpg";
import "./projects.css";

const photos1 = [
  {
    src: proj1_1,
    width: 4,
    height: 5,
  },
  {
    src: proj1_2,
    width: 3,
    height: 5,
  },
  {
    src: proj1_3,
    width: 2,
    height: 3,
  },
];
const photos2 = [
  {
    src: proj1_4,
    width: 2,
    height: 3,
  },
  {
    src: proj1_5,
    width: 2,
    height: 2,
  },
  {
    src: proj1_6,
    width: 4,
    height: 5,
  },
  {
    src: proj1_7,
    width: 3,
    height: 2,
  },
];

function Project1() {
  return (
    <div className="projectsection">
      <div className="inclusiontext">
        <h4 className="headingtext">
          <strong>PROJECT_01: UNSPOKEN VIOLENCE</strong>
        </h4>
      </div>
      <div className="inclusiontext">
        <p>
          In 2017, TIPTOE& partnered with Greeen Tree Youth Violence Prevention
          Foundation, a leading NGO which prevents school violence in South
          Korea. Our partnership directed Korean public's attention to{" "}
          <strong>Project_01: Unspoken Violence</strong> through which we
          donated to provide medical treatment to a victim of school violence.
        </p>
      </div>
      <div className="photogallery">
        <Gallery photos={photos1} />
        <Gallery photos={photos2} />
      </div>
    </div>
  );
}

export { Project1 };
